import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, CheckIcon, Edit, Pencil, Trash2 } from "lucide-react";
// @ts-ignore
import moment from "moment-jalaali";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  handleUpdateDataClick: (data: any) => void;
  columnName: (data: any) => void;
  savaDataToPDF: (data: any) => void;
}

const BurdanFarmerColumn = ({
  onClickDelete,
  handleUpdateDataClick,
  savaDataToPDF,
  columnName,
}: ColumnsProps) => {
  return [
    {
      header: "سال زراعی",
      accessorKey: "crop_year_name",
    },
    {
      header: "ذخیره",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => (
        <div className="flex gap-2">
          <button
            className="px-2 py-1 text-white bg-orange-600 rounded-md"
            onClick={() => savaDataToPDF(cell.row.original)}
          >
            ذخیره
          </button>
        </div>
      ),
    },

    {
      header: "نام کشاورز",
      accessorKey: "farmer_name",
      enableColumnFilter: false,
    },
    {
      header: "کارخانه",
      accessorKey: "factory_name",
      enableColumnFilter: false,
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("date")}
        >
          <span>تاریخ </span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),
      accessorKey: "date",
      enableColumnFilter: false,
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("load_number")}
        >
          <span> شماره بارنامه </span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),
      accessorKey: "load_number",
      enableColumnFilter: false,
    },
    {
      header: "نام راننده",
      accessorKey: "driver_name",
      enableColumnFilter: false,
    },
    {
      header: "شماره همراه",
      accessorKey: "phone_number",
      enableColumnFilter: false,
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("total_weight")}
        >
          <span> وزن کل (کیلوگرم)</span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),

      accessorKey: "total_weight",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("dirt_weight")}
        >
          <span> وزن خاک (کیلوگرم) </span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),

      accessorKey: "dirt_weight",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "وزن آفت (کیلوگرم)",
      accessorKey: "pest_weight",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "وزن خالص (کیلوگرم)",
      accessorKey: "pure_weight",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "عیار چغندر",
      accessorKey: "sugar_beet_polarity",
      enableColumnFilter: false,
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("guarantee_price")}
        >
          <span> قیمت هر کیلو </span>
          <span className="text-blue-600 text-[10px]">(ریال)</span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),
      accessorKey: "price_per_kilo",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "کمک  کرایه",
      accessorKey: "rent_help",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "کرایه حمل",
      accessorKey: "transportation_cost",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "بهای قند سهمیه",
      accessorKey: "quota_sugar_price",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "بهای تفاله سهمیه",
      accessorKey: "quota_pulp_price",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("guarantee_price")}
        >
          <span> خالص پرداختی </span>
          <span className="text-blue-600 text-[10px]">(ریال)</span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),

      accessorKey: "pure_payable",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return <span>{cell.getValue()?.toLocaleString()}</span>;
      },
    },
    {
      header: "عملیات",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => (
        <div className="flex gap-2">
          <button
            className="px-2 py-1 text-white bg-blue-500 rounded-md"
            onClick={() => handleUpdateDataClick(cell.row.original)}
          >
            ویرایش
          </button>
          <button
            className="px-2 py-1 text-white bg-red-500 rounded-md"
            onClick={() => onClickDelete(cell.row.original)}
          >
            حذف
          </button>
        </div>
      ),
    },
  ];
};

export default BurdanFarmerColumn;
